
import { Component, OnInit } from '@angular/core';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';
import { StepperAllModule, StepperModule } from '@syncfusion/ej2-angular-navigations';
import { IStepAuthenticateData } from '../two-factor-authentication/steps/step-authenticate/step-authenticate.component';
import { StepQrcodeComponent } from '../two-factor-authentication/steps/step-qrcode/step-qrcode.component';
import { StepVerifyRegistrationComponent, ValidateFormType } from '../two-factor-authentication/steps/step-verify-registration/step-verify-registration.component';
import { StepRegistrationSuccessfulComponent } from '../two-factor-authentication/steps/step-registration-successful/step-registration-successful.component';
import { IRequest2FARegistrationCodeResponseDTO, Request2FARegistrationCodeDTO, Request2FARegistrationCodeResponseDTO, Verify2FARegistrationCodeDTO } from '../models/models.swagger.generated';
import { twoFactorAuthenticationRecoveryRoute } from 'src/app/core/routing/route-names';
import { FormGroup } from '@angular/forms';
import { TwoFactorAuthenticationRegistrationService } from '../two-factor-authentication/two-factor-authentication-registration.service';
import { SetPasswordResult, SetPasswordComponent } from '../set-password/set-password.component';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
    selector: 'app-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    imports: [TitleBarComponent, SetPasswordComponent, StepperAllModule, StepperModule, StepQrcodeComponent, StepVerifyRegistrationComponent, StepRegistrationSuccessfulComponent]
})
export class OnboardingComponent implements OnInit {
  public loading = false;
  public qrData: IRequest2FARegistrationCodeResponseDTO;
  public stepIndex = 0;
  public stepAuthenticateData: IStepAuthenticateData = {
    header: 'i18n.base.two-factor-authentication.registration.step1-header',
    description: 'i18n.base.two-factor-authentication.registration.step1-description',
    linkLabel: 'i18n.base.two-factor-authentication.registration.recover-2FA',
    linkRoute: twoFactorAuthenticationRecoveryRoute,
    buttonText: 'i18n.base.two-factor-authentication.registration.get-code'
  };

  private userId: string;
  private verificationToken: string;
  private faToken: string;
  private password: string;

  public get areParametersValid(): boolean {
    if (this.userId && this.verificationToken && this.faToken) {
      return true;
    }
    else {
      return false;
    }
  }

  constructor(authService: AuthService, private service: TwoFactorAuthenticationRegistrationService, private route: ActivatedRoute) {
    if (authService.isUserLoggedIn()) {
      authService.logout();
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.userId = params.userId;
      this.verificationToken = params.code;
      this.faToken = params.faCode;
    });
  }

  public onPasswordSet(data: SetPasswordResult): void {
    if (!data.success || this.loading) {
      return;
    }
    this.password = data.password;
    var request = new Request2FARegistrationCodeDTO({userId: this.userId, password: data.password});
    this.service.requestCode(request).subscribe({
      next: (response: Request2FARegistrationCodeResponseDTO) => {
        this.qrData = response;
        this.loading = false;
        this.stepIndex = 1;
      },
      error: () => {
        this.loading = false;
      }
    });
  }


  public onQrCodeRegistered(): void {
    this.stepIndex = 2;
  }

  public validateRegistration(validateForm: FormGroup<ValidateFormType>): void {
    if (validateForm.invalid || this.loading) {
      return;
    }
    this.service.verifyRegistration(new Verify2FARegistrationCodeDTO({userId: this.userId, password: this.password, code: validateForm.value.token})).subscribe({
      next: () => {
        this.loading = false;
        this.stepIndex = 3;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

}
